import React, { useState } from "react";
import { Layout } from "../../layouts/Layout";
import "./Contact-us.css";

const contactDetails = [
  {
    icon: "fas fa-map-marker-alt",
    title: "Office Address",
    lines: ["3FCS08, Corporate Suites, Ansal Plaza, Vaishali, Ghaziabad"],
  },
  {
    icon: "fas fa-phone-volume",
    title: "Call Us",
    lines: ["+91 9990573703", "Monday–Saturday, 9:30 AM–6:30 PM"],
    href: "tel:+919990573703",
  },
  {
    icon: "fas fa-envelope-open-text",
    title: "Email Us",
    lines: ["info@globizindia.in", "We usually reply within one business day"],
    href: "mailto:info@globizindia.in",
  },
];

const serviceOptions = [
  "Company Secretarial Services",
  "Legal Services",
  "Consultancy Services",
  "Business Incorporation",
  "ROC & Regulatory Compliance",
  "FEMA & RBI Advisory",
  "Other",
];

const initialForm = {
  name: "",
  email: "",
  phone: "",
  company: "",
  service: "",
  message: "",
  consent: false,
};

const ContactPage = () => {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;

    setForm((previous) => ({
      ...previous,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (errors[name]) {
      setErrors((previous) => ({ ...previous, [name]: "" }));
    }

    if (submitted) {
      setSubmitted(false);
    }
  };

  const validateForm = () => {
    const nextErrors = {};

    if (!form.name.trim()) {
      nextErrors.name = "Please enter your full name.";
    }

    if (!form.email.trim()) {
      nextErrors.email = "Please enter your email address.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      nextErrors.email = "Please enter a valid email address.";
    }

    if (!form.phone.trim()) {
      nextErrors.phone = "Please enter your phone number.";
    } else if (!/^[0-9+\-\s()]{8,18}$/.test(form.phone)) {
      nextErrors.phone = "Please enter a valid phone number.";
    }

    if (!form.service) {
      nextErrors.service = "Please select a service.";
    }

    if (!form.message.trim()) {
      nextErrors.message = "Please tell us how we can help.";
    }

    if (!form.consent) {
      nextErrors.consent = "Please accept the consent checkbox.";
    }

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    /*
      Connect your API here.

      Example:
      await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
    */

    setSubmitted(true);
    setForm(initialForm);
  };

  return (
    <Layout header={4} footer={2} breadcrumb="Contact Us" title="Contact Us">
      <section className="contact-intro-area">
        <div className="contact-shape contact-shape-one"></div>
        <div className="contact-shape contact-shape-two"></div>

        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-xl-6 col-lg-6">
              <div className="contact-intro-content" data-aos="fade-right">
                <span className="contact-subtitle">Let’s Work Together</span>

                <h2>
                  Professional guidance for every stage of your business journey.
                </h2>

                <p>
                  Speak with our corporate, legal and compliance professionals
                  for practical advice tailored to your organisation. Share your
                  requirement and our team will connect with you shortly.
                </p>

                <div className="contact-highlight-list">
                  <div className="contact-highlight-item">
                    <span className="contact-highlight-icon">
                      <i className="fas fa-shield-alt"></i>
                    </span>

                    <div>
                      <h4>Confidential Consultation</h4>
                      <p>Your information is handled professionally and securely.</p>
                    </div>
                  </div>

                  <div className="contact-highlight-item">
                    <span className="contact-highlight-icon">
                      <i className="fas fa-user-tie"></i>
                    </span>

                    <div>
                      <h4>Experienced Professionals</h4>
                      <p>Receive guidance from specialists who understand business.</p>
                    </div>
                  </div>

                  <div className="contact-highlight-item">
                    <span className="contact-highlight-icon">
                      <i className="far fa-clock"></i>
                    </span>

                    <div>
                      <h4>Prompt Response</h4>
                      <p>Our team aims to respond within one working day.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-6 col-lg-6">
              <div className="contact-form-card" data-aos="fade-left">
                <div className="contact-form-heading">
                  <span>Request a Consultation</span>
                  <h3>Tell us how we can help</h3>
                  <p>Complete the form and our team will contact you.</p>
                </div>

                {submitted && (
                  <div className="contact-success-message" role="status">
                    <i className="fas fa-check-circle"></i>
                    <div>
                      <strong>Thank you for contacting us.</strong>
                      <span>Your enquiry has been recorded successfully.</span>
                    </div>
                  </div>
                )}

                <form className="contact-form" onSubmit={handleSubmit} noValidate>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="contact-field">
                        <label htmlFor="name">
                          Full Name <span>*</span>
                        </label>
                        <div className="contact-input-wrap">
                          <i className="far fa-user"></i>
                          <input
                            id="name"
                            name="name"
                            type="text"
                            value={form.name}
                            onChange={handleChange}
                            placeholder="Enter your full name"
                          />
                        </div>
                        {errors.name && (
                          <small className="contact-error">{errors.name}</small>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="contact-field">
                        <label htmlFor="phone">
                          Phone Number <span>*</span>
                        </label>
                        <div className="contact-input-wrap">
                          <i className="fas fa-phone-alt"></i>
                          <input
                            id="phone"
                            name="phone"
                            type="tel"
                            value={form.phone}
                            onChange={handleChange}
                            placeholder="+91 98765 43210"
                          />
                        </div>
                        {errors.phone && (
                          <small className="contact-error">{errors.phone}</small>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="contact-field">
                        <label htmlFor="email">
                          Email Address <span>*</span>
                        </label>
                        <div className="contact-input-wrap">
                          <i className="far fa-envelope"></i>
                          <input
                            id="email"
                            name="email"
                            type="email"
                            value={form.email}
                            onChange={handleChange}
                            placeholder="name@company.com"
                          />
                        </div>
                        {errors.email && (
                          <small className="contact-error">{errors.email}</small>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="contact-field">
                        <label htmlFor="company">Company Name</label>
                        <div className="contact-input-wrap">
                          <i className="far fa-building"></i>
                          <input
                            id="company"
                            name="company"
                            type="text"
                            value={form.company}
                            onChange={handleChange}
                            placeholder="Enter company name"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="contact-field">
                        <label htmlFor="service">
                          Service Required <span>*</span>
                        </label>
                        <div className="contact-input-wrap contact-select-wrap">
                          <i className="fas fa-briefcase"></i>
                          <select
                            id="service"
                            name="service"
                            value={form.service}
                            onChange={handleChange}
                          >
                            <option value="">Select a service</option>
                            {serviceOptions.map((service) => (
                              <option key={service} value={service}>
                                {service}
                              </option>
                            ))}
                          </select>
                        </div>
                        {errors.service && (
                          <small className="contact-error">{errors.service}</small>
                        )}
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="contact-field">
                        <label htmlFor="message">
                          Your Requirement <span>*</span>
                        </label>
                        <div className="contact-input-wrap contact-textarea-wrap">
                          <i className="far fa-comment-dots"></i>
                          <textarea
                            id="message"
                            name="message"
                            rows="5"
                            value={form.message}
                            onChange={handleChange}
                            placeholder="Briefly describe your requirement"
                          ></textarea>
                        </div>
                        {errors.message && (
                          <small className="contact-error">{errors.message}</small>
                        )}
                      </div>
                    </div>

                    <div className="col-12">
                      <label className="contact-consent">
                        <input
                          type="checkbox"
                          name="consent"
                          checked={form.consent}
                          onChange={handleChange}
                        />
                        <span className="contact-checkbox">
                          <i className="fas fa-check"></i>
                        </span>
                        <span>
                          I consent to being contacted regarding my enquiry.
                        </span>
                      </label>

                      {errors.consent && (
                        <small className="contact-error contact-consent-error">
                          {errors.consent}
                        </small>
                      )}
                    </div>

                    <div className="col-12">
                      <button type="submit" className="contact-submit-btn">
                        <span>Submit Enquiry</span>
                        <i className="fas fa-arrow-right"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-info-area">
        <div className="container">
          <div className="row g-4">
            {contactDetails.map((item, index) => {
              const content = (
                <>
                  <span className="contact-info-icon">
                    <i className={item.icon}></i>
                  </span>

                  <div className="contact-info-content">
                    <h3>{item.title}</h3>
                    {item.lines.map((line) => (
                      <p key={line}>{line}</p>
                    ))}
                  </div>

                  <span className="contact-info-arrow">
                    <i className="fas fa-external-link-alt"></i>
                  </span>
                </>
              );

              return (
                <div
                  className="col-lg-4 col-md-6"
                  key={item.title}
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                >
                  {item.href ? (
                    <a className="contact-info-card" href={item.href}>
                      {content}
                    </a>
                  ) : (
                    <div className="contact-info-card">{content}</div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="contact-map-area">
        <div className="container">
          <div className="contact-map-box" data-aos="fade-up">
            <div className="contact-map-content">
              <span className="contact-subtitle">Visit Our Office</span>
              <h2>Meet our professionals and discuss your business requirements.</h2>
              <p>
                Schedule an appointment before visiting so the appropriate
                specialist is available to assist you.
              </p>

              <div className="contact-map-actions">
                <a
                  href="https://maps.google.com"
                  target="_blank"
                  rel="noreferrer"
                  className="contact-primary-link"
                >
                  <i className="fas fa-location-arrow"></i>
                  Get Directions
                </a>

                <a href="tel:+919990573703" className="contact-secondary-link">
                  <i className="fas fa-phone-alt"></i>
                  Schedule a Call
                </a>
              </div>
            </div>

            <div className="contact-map-placeholder">
              <div className="contact-map-grid"></div>
              <span className="contact-map-pin">
                <i className="fas fa-map-marker-alt"></i>
              </span>
              <div className="contact-map-label">
                <strong>Globiz India</strong>
                <span>New Delhi, India</span>
              </div>
            </div>
          </div>
        </div>
      </section>

    

      <section className="contact-cta-area">
        <div className="container">
          <div className="contact-cta-box" data-aos="zoom-in">
            <div className="contact-cta-icon">
              <i className="fas fa-handshake"></i>
            </div>

            <div className="contact-cta-copy">
              <span>Need immediate professional assistance?</span>
              <h2>Let’s discuss the right solution for your business.</h2>
            </div>

            <a href="tel:+918287234369" className="contact-cta-btn">
              <i className="fas fa-phone-volume"></i>
              Call Our Team
            </a>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default ContactPage;
